import './optionalSection.css'

import React, { FC, ReactNode } from 'react'

const RawOptionalSection: FC<{ visible: boolean; children: ReactNode }> = ({
  visible,
  children,
}) => {
  return (
    <div className={visible ? 'visible-section' : 'hidden-section'}>
      {children}
    </div>
  )
}

export const OptionalSection = React.memo(RawOptionalSection)
